import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Form, Modal, Button } from 'ui'
import { IntlService, KwkService } from 'services'
import * as socialChannels from './channels'
import { StepOne, StepTwo, StepThree } from '../modalsteps'

// TODO: This needs to be moved to src/Components/socialShare
export default function SocialShareModal({ productArea, acSelector }) {
  const [step, setStep] = useState(0)
  const [channel, setChannel] = useState([])
  const [customerNumber, setCustomerNumber] = useState(0)
  const [promotionLink, setPromotionLink] = useState('')
  const [show, setShow] = useState(false)

  let shareUrl = ''
  // FIXME: This mapping needs to be made dynamic and unified
  const channelList = [
    ['whatsapp-msg', 'Whatsapp'],
    ['fb-msg', 'Messenger'],
    ['telegram-msg', 'Telegram'],
    ['threema-msg', 'Threema']
  ]
  const channels = channelList.map(channelArray => channelArray[0])

  // TODO: The may be a better way to handle this Hook for multiple state values
  useEffect(() => {
    setStep(step)
    setChannel(channel)
    setCustomerNumber(customerNumber)
    setShow(show)
  }, [step, setStep, channel, setChannel, customerNumber, setCustomerNumber, show, setShow])

  // NOTE: These handlers are for the Modal (show / close)
  const handleClose = () => {
    setShow(false)
    setStep(0)
    setPromotionLink('')
    setChannel(null)
  }
  const handleShow = () => {
    setShow(true)
    setStep(step + 1)
  }

  const onSubmitHandler = async (e, { data }) => {
    KwkService.setCustomerNumber(data.value)
    let finalChannel

    if (acSelector) {
      finalChannel = acSelector
    } else {
      finalChannel = channel.id
    }

    shareUrl = await KwkService.createPromotionLink({ channel: finalChannel, productArea })
    setPromotionLink(shareUrl)
    setStep(step + 1)
  }

  // FIXME: There's a more elegant solution for this function
  const onChannelShare = e => {
    const chosenChannel = channels.filter(c => {
      return e.currentTarget.getAttribute('class').indexOf(c) >= 0 ? c : null
    })
    setStep(step + 1)
    setChannel(
      chosenChannel.length >= 0 ? socialChannels[chosenChannel[0].substring(0, chosenChannel[0].indexOf('-msg'))] : null
    )
  }

  // FIXME: Should be made safer and is a pitfall
  if (promotionLink !== '') {
    shareUrl = channel
      .createShareUrl({
        title: encodeURIComponent(
          IntlService.get(`socialshare.channels.${channel.id}.title`) || 'Meine Empfehlung für Dich!'
        ),
        text: encodeURIComponent(IntlService.get(`socialshare.channels.${channel.id}.text`) || 'Top Angebote bei 1&1'),
        url: encodeURIComponent(promotionLink)
      })
      .replace(/%7BURL%7D/g, encodeURIComponent(promotionLink))
  }

  return (
    <>
      <Button secondary icon={'share'} onClick={handleShow}>
        Share
      </Button>
      <Modal size="md" hasCloseButton={true} open={show} onClose={handleClose}>
        <Modal.Body>
          <div className="socialshare-modal">
            <Form method="POST" onSubmit={onSubmitHandler} noAction>
              <StepOne onClick={onChannelShare} channels={channelList} step={step} />
              <StepTwo step={step} />
              <StepThree step={step} targetUrl={promotionLink} shareUrl={shareUrl} />
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

SocialShareModal.propTypes = {
  content: PropTypes.string,
  productArea: PropTypes.oneOf(['dsl', 'allnetflat', 'dataflat']),
  acSelector: PropTypes.string
}

SocialShareModal.defaultProps = {
  productArea: 'dsl',
  acSelector: ''
}
